import Vue from 'vue';

Vue.mixin({
  methods: {
    getRawObject: function (source) {
      return JSON.parse(JSON.stringify(source));
    },

    formatDate (date) {
      return Vue.prototype.$date(date).format('DD/MM/YYYY hh:mm:ss a');
    }
  }
});
